<template>
    <div class="mt-3">
        <div class="w-full">
            <h1 class="text-3xl text-center">
                Grupos de ordenes en total
                <strong class="text-theme-primary">
                    {{ itemsNumber }}
                </strong>
            </h1>
        </div>

        <div class="flex flex-wrap mt-2">
            <div class="flex justify-between flex-col lg:flex-row w-full">
                <div class="my-3 flex justify-around">
                    <app-button v-show="query" relief @click="reloadItems">
                        Consultar 🔎
                    </app-button>
                </div>

                <div class="my-3 flex items-end justify-center">
                    <custom-pagination
                        v-model="currentPage"
                        :length="pagesNumber"
                        @input="listItems()"
                    />
                </div>
            </div>
        </div>

        <div class="w-full mt-2">
            <custom-table
                ref="selectableTable"
                :fields="$data.$fields"
                :items="itemsCurrent"
                :per-page="itemsCurrent.length"
                select-mode="multi"
                responsive
                outlined
                no-border-collapse
                hover
                selectable
                class="w-full"
                items-empty-message="Nuestro sistema NO encuentra resultados."
                @flex-selected="onRowSelected"
            >
                <template #cell(id)="data">
                    <div class="flex items-center">
                        <router-link
                            :to="`/app/orders-groups/detail/${data.item.id}`"
                            class="text-center btn btn-stack-primary p-1"
                        >
                            <span> {{ data.item.id }}</span>
                        </router-link>
                    </div>
                </template>
                <template #cell(deliveryStatusGroup)="data">
                    <span
                        class="text-center"
                        :class="
                            $data.$ordersStatusesGroupMessageClass[
                                data.item.deliveryStatusGroup
                            ]
                        "
                    >
                        {{
                            $data.$ordersStatusesGroupCodes[
                                data.item.deliveryStatusGroup
                            ]
                        }}
                    </span>
                </template>

                <template #cell(paymentStatusGroup)="data">
                    <span
                        class="text-center"
                        :class="
                            $data.$ordersGroupsPaymentStatusMessageClass[
                                data.item.paymentStatusGroup
                            ]
                        "
                    >
                        {{
                            $data.$ordersGroupsPaymentStatusCodes[
                                data.item.paymentStatusGroup
                            ]
                        }}
                    </span>
                </template>

                <template #cell(createdAt)="data">
                    <span class="text-center">
                        {{ data.item.createdAt | date }}
                    </span>
                </template>
                <template #cell(updatedAt)="data">
                    <span class="text-center">
                        {{ data.item.updatedAt | date }}
                    </span>
                </template>
            </custom-table>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import {
    ordersStatusesGroupCodes,
    ordersStatusesGroupMessageClass
} from "@/common/fields/delivery-status-group-codes";
import {
    ordersGroupsPaymentStatusCodes,
    ordersGroupsPaymentStatusMessageClass
} from "@/common/fields/orders-groups-payment-status-group-codes";

import CustomTable from "@/components/utils/CustomTable.vue";

export default {
    name: "OrdersGroupsIndex",
    components: { CustomTable },
    layout: "app",
    data: () => ({
        itemsCurrent: [],
        $ordersStatusesGroupCodes: ordersStatusesGroupCodes,
        $ordersStatusesGroupMessageClass: ordersStatusesGroupMessageClass,
        $ordersGroupsPaymentStatusMessageClass:
            ordersGroupsPaymentStatusMessageClass,
        $ordersGroupsPaymentStatusCodes: ordersGroupsPaymentStatusCodes,
        $fields: [
            { key: "id", label: "ID", sortable: false },
            {
                key: "deliveryStatusGroup",
                label: "Estado",
                sortable: true
            },
            {
                key: "paymentStatusGroup",
                label: "Estado de pago",
                sortable: false
            },
            { key: "createdAt", label: "📆 Creación", sortable: true },
            { key: "updatedAt", label: "📆 Actualización", sortable: true }
        ],

        currentPage: 1,
        pagesNumber: 0,
        itemsNumber: 0,
        loadedAllData: false,
        isLoadingAllData: false,
        itemsAll: [],
        selected: [],
        query: {}
    }),
    computed: {
        ...mapState("orders", ["orders"]),
        ...mapGetters("control", ["backgroundColor"])
    },
    watch: {},
    async mounted() {
        const verifyPagePermission =
            this.$ability.verifyPagePermission.bind(this);
        if (!(await verifyPagePermission("orderGroup:List", "/app"))) return;
        this.listItems(true);
    },
    methods: {
        ...mapActions("orders", ["listOrdersGroupsPaginated"]),
        async listItems(complete = false) {
            this.isLoading = true;
            this.$loading.show();
            try {
                const { items, pagination } =
                    await this.listOrdersGroupsPaginated({
                        query: {
                            complete,
                            page: this.currentPage,
                            ...this.query
                        }
                    });
                this.itemsCurrent = items;
                if (pagination) {
                    this.itemsNumber = pagination.itemsNumber;
                    this.pagesNumber = pagination.pagesNumber;
                }
                this.$loading.hide();
            } catch (error) {
                this.$loading.hide();
                this.isLoading = false;
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async reloadItems() {
            this.currentPage = 1;
            await this.listItems(true);
        },
        onRowSelected(items) {
            this.selected = items;
        },
        clearSelected() {
            this.$refs.selectableTable.clearSelected();
            this.selected = [];
        }
    }
};
</script>
